"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var walkThroughPrototypes_1 = require("./utils/walkThroughPrototypes");
var emit_1 = require("./utils/emit");
var LifecycleElement = /** @class */ (function (_super) {
    tslib_1.__extends(LifecycleElement, _super);
    function LifecycleElement() {
        var _this = _super.call(this) || this;
        _this.props = {};
        // to prevent render when element is not attached or for batch operations
        _this.preventRender = true;
        _this.hadOwnProperties = {};
        for (var propName in _this.constructor.observedProperties) {
            if (_this.hasOwnProperty(propName)) {
                // remember properties that were set before constructor
                _this.hadOwnProperties[propName] = _this[propName];
            }
        }
        return _this;
    }
    Object.defineProperty(LifecycleElement, "observedProperties", {
        get: function () {
            return walkThroughPrototypes_1.collectAncestralProperties(this, '_observedProperties').reduce(function (acc, props) { return (tslib_1.__assign({}, acc, props)); }, {});
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LifecycleElement, "observedAttributes", {
        get: function () {
            return walkThroughPrototypes_1.collectAncestralProperties(this, '_observedAttributes').reduce(function (acc, attrs) { return acc.concat(attrs); }, []);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Called after element is appended to DOM
     */
    LifecycleElement.prototype.connectedCallback = function () {
        this.elementConnected = true;
        var self = this;
        // if component had own props before constructor we ignore props set in constructor
        for (var propName in this.hadOwnProperties) {
            // delete own properties so component will use getters/setter defined in proto
            delete self[propName];
            self[propName] = self.hadOwnProperties[propName];
        }
        // if some props were set in constructor then rerun setters to turn them into attrs
        if (this._reserializeProps) {
            this._reserializeProps.forEach(function (prop) {
                self[prop] = self.props[prop];
            });
            this._reserializeProps = null;
        }
        this.preventRender = false;
        this.rendererCallback();
    };
    /**
     * Called after attribute is set
     * @param attrName name of the attribute (dash-cased)
     * @param oldAttr previous value of the attribute
     * @param newAttr new value of the attribute
     */
    LifecycleElement.prototype.attributeChangedCallback = function (attrName, oldAttr, newAttr) {
        if (oldAttr !== newAttr) {
            var observedProperties = this.constructor.observedProperties;
            var propName = void 0;
            for (var prop in observedProperties) {
                if (observedProperties[prop].propToAttribute(prop) === attrName) {
                    propName = prop;
                }
            }
            if (propName) {
                var oldValue = this.props[propName];
                var newValue = observedProperties[propName].deserialize(this, propName);
                if (oldValue !== newValue) {
                    this.props[propName] = newValue;
                    // if there is a custom setter it needs to be called
                    // default one will update attr with the same value and attrChangedCb will exit immediately
                    this[propName] = newValue;
                    this.propsChangedCallback(propName, oldValue, this.props[propName]);
                }
            }
        }
    };
    LifecycleElement.prototype.propsChangedCallback = function (propName, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.rendererCallback();
        }
    };
    LifecycleElement.prototype.rendererCallback = function () {
        if (!this.preventRender) {
            this.renderCallback();
        }
    };
    /**
     * Called at the end of lifecycle. Usually DOM changes happen here
     */
    LifecycleElement.prototype.renderCallback = function () { };
    /**
     * Called after element is removed from DOM
     */
    LifecycleElement.prototype.disconnectedCallback = function () {
        this.elementConnected = false;
        this.preventRender = true;
    };
    /**
     * Custom event emitting
     * @param eventName
     * @param detail
     * @param eventParams
     */
    LifecycleElement.prototype.emit = function (eventName, detail, eventParams) {
        var withoutPrefix = eventName.slice(2);
        var eventNameWithoutOn = withoutPrefix.charAt(0).toLowerCase() + withoutPrefix.substring(1);
        emit_1.emit(this, eventNameWithoutOn, detail, eventParams);
    };
    LifecycleElement.prototype.setProperties = function (properties) {
        this.preventRender = true;
        for (var key in properties) {
            if (properties.hasOwnProperty(key)) {
                this[key] = properties[key];
            }
        }
        this.preventRender = false;
        this.rendererCallback();
    };
    return LifecycleElement;
}(HTMLElement));
exports.LifecycleElement = LifecycleElement;
